const MahsupTipi = {
    0: "Oluşturuldu",
    1: "Onaylandi",
    2: "Odeme Emrine Baglandi",
    3: "Kurum Emanetine Aktarıldı",
    5: "Mahsup Tamamlandi"
}

export default MahsupTipi;
